import React from 'react';
import withFormContainer from './withFormContainer.jsx';

import './DeleteForm.css';

class DeleteForm extends React.Component {

    render() {
        return (
            <div className="delete-form">

                <h3 className="form-container-header">
                    Remove this comment?
                </h3>

                <button
                    type="button"
                    className="btn danger-button"
                    onClick={this.props.onRemove}
                >
                    Remove
                </button>

                <button
                    type="button"
                    className="btn secondary-button"
                    value={this.props.closeValue}
                    onClick={this.props.close}
                >
                    Cancel
                </button>

            </div>
        );
    }
}

export default withFormContainer(DeleteForm);


// WEBPACK FOOTER //
// ./src/components/DeleteForm.jsx